<template>
  <div class="propertyManage">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">标的物管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <el-input
              v-model="filters.propertyCode"
              size="small"
              class="search-input"
              clearable
              placeholder="请输入标的物编号"
              @keyup.enter.native="loadList(1)"
            />
          </div>
          <div class="select-container-box">
            <el-select v-model="filters.subType" size="small" clearable placeholder="请选择子类型">
              <el-option
                v-for="item in subTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-select v-model="filters.status" size="small" class="long-select" clearable placeholder="请选择使用状态">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-select v-model="filters.auditStatus" size="small" class="long-select" clearable placeholder="请选择审核状态">
              <el-option
                v-for="item in auditStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="loadList(1)">查询</el-button>
            <el-button size="small" type="info" plain @click="resetSearch">重置</el-button>
            <el-button size="small" type="info" plain class="add" v-if="edit" @click="handleAdd">增加</el-button>
            <el-button size="small" class="lease-btn-import" v-if="edit" @click="openImport">导入</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="list" style="width:100%;" size="medium" v-loading="loading">
          <i slot="empty" style="font-style:normal">暂无数据</i>
          <el-table-column
            prop="propertyCode"
            label="标的物编号"
            align="center"
            min-width="120"
            show-overflow-tooltip
          />
          <el-table-column label="标的物类型" align="center" min-width="110">
            <template slot-scope="scope">
              {{ typeLabel(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="标的物地址"
            align="center"
            min-width="140"
            show-overflow-tooltip
          />
          <el-table-column prop="area" label="面积(亩)" align="center" width="100" />
          <el-table-column prop="propertyRent" label="租金(元/年)" align="center" width="110" />
          <el-table-column label="使用状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="isUsageStatusHidden(scope.row)">--</span>
              <LeaseStatusTag
                v-else
                kind="property"
                :value="scope.row.status"
              />
            </template>
          </el-table-column>
          <el-table-column label="审核状态" align="center" width="100">
            <template slot-scope="scope">
              <LeaseStatusTag kind="audit" :value="scope.row.auditStatus" />
            </template>
          </el-table-column>
          <el-table-column label="驳回原因" align="center" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    Number(scope.row.auditStatus) === LeaseAuditStatus.Rejected
                      ? '#f56c6c'
                      : ''
                }"
                >{{ scope.row.auditRemark || "--" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="340" fixed="right">
            <template slot-scope="scope">
              <span class="content-edit" @click="goDetail(scope.row)">详情</span>
              <span
                v-if="canEdit(scope.row)"
                class="content-edit"
                style="margin-left:12px;"
                @click="handleEdit(scope.row)"
              >编辑</span>
              <span
                v-if="canEdit(scope.row)"
                class="content-del"
                style="margin-left:12px;"
                @click="handleDelete(scope.row)"
              >删除</span>
              <span
                v-if="canDisable(scope.row)"
                class="content-edit"
                style="margin-left:12px;color:#e6a23c;"
                @click="openDisable(scope.row)"
              >禁用</span>
              <span
                v-if="canSubmit(scope.row)"
                class="content-edit"
                style="margin-left:12px;"
                @click="handleSubmit(scope.row)"
              >提交审核</span>
              <span
                v-if="canViewContract(scope.row)"
                class="content-edit"
                style="margin-left:12px;"
                @click="goViewContract(scope.row)"
              >查看合同</span>
              <span
                v-else-if="canCreateContract(scope.row)"
                class="content-edit"
                style="margin-left:12px;"
                @click="goCreateContract(scope.row)"
              >创建合同</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>

    <property-form-dialog ref="formDialog" @success="loadList()" />
    <import-excel-dialog
      ref="importDialog"
      title="导入标的物"
      :download-fn="downloadPropertyImportTemplate"
      :import-fn="importPropertyExcel"
      @success="loadList(1)"
    />

    <el-dialog
      title="禁用标的物"
      :visible.sync="disableVisible"
      width="480px"
      custom-class="lease-ylw-dialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form label-width="90px" size="small">
        <el-form-item label="禁用原因" required>
          <el-input
            v-model="disableReason"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入禁用原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="disableVisible = false">取消</el-button>
        <el-button type="primary" :loading="disabling" @click="confirmDisable">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageChange from "@/components/common/PageChange.vue";
import mixins from "@/common/MixIn.js";
import ImportExcelDialog from "@/components/fishPondLease/common/ImportExcelDialog.vue";
import LeaseStatusTag from "@/components/fishPondLease/common/LeaseStatusTag.vue";
import PropertyFormDialog from "./PropertyFormDialog.vue";
import {
  pageProperty,
  deleteProperty,
  disableProperty,
  submitPropertyAudit,
  downloadPropertyImportTemplate,
  importPropertyExcel,
  leaseRequestError
} from "@/service/fishPondLease.js";
import {
  PropertyType,
  PropertyStatus,
  LeaseAuditStatus,
  PropertySubTypeOptions,
  PropertyStatusOptions,
  LeaseAuditStatusOptions,
  enumLabel
} from "@/service/fishPondLeaseEnums.js";

export default {
  name: "PropertyManage",
  mixins: [mixins],
  components: {
    PageChange: PageChange,
    ImportExcelDialog: ImportExcelDialog,
    PropertyFormDialog: PropertyFormDialog,
    LeaseStatusTag: LeaseStatusTag
  },
  data: function() {
    return {
      loading: false,
      list: [],
      filters: {
        propertyCode: "",
        subType: "",
        status: "",
        auditStatus: ""
      },
      subTypeOptions: PropertySubTypeOptions,
      statusOptions: PropertyStatusOptions,
      auditStatusOptions: LeaseAuditStatusOptions,
      pageInfo: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
        pageFunc: this.loadList
      },
      downloadPropertyImportTemplate: downloadPropertyImportTemplate,
      importPropertyExcel: importPropertyExcel,
      disableVisible: false,
      disabling: false,
      disableReason: "",
      currentRow: null,
      LeaseAuditStatus: LeaseAuditStatus
    };
  },
  mounted: function() {
    this.loadList(1);
  },
  methods: {
    enumLabel: enumLabel,
    typeLabel: function(row) {
      var typeTxt = enumLabel("propertyType", row.type);
      if (Number(row.type) === PropertyType.FishPond && row.subType != null && row.subType !== "") {
        return typeTxt + "/" + enumLabel("propertySubType", row.subType);
      }
      return typeTxt;
    },
    isUsageStatusHidden: function(row) {
      var audit = Number(row.auditStatus);
      return (
        audit === LeaseAuditStatus.PendingSubmit ||
        audit === LeaseAuditStatus.Pending ||
        audit === LeaseAuditStatus.Rejected
      );
    },
    canEdit: function(row) {
      return (
        Number(row.auditStatus) !== LeaseAuditStatus.Pending &&
        Number(row.status) !== PropertyStatus.Rented
      );
    },
    canDisable: function(row) {
      var status = Number(row.status);
      var audit = Number(row.auditStatus);
      return (
        (status === PropertyStatus.Idle || status === PropertyStatus.Rented) &&
        audit === LeaseAuditStatus.Approved
      );
    },
    canSubmit: function(row) {
      var status = Number(row.auditStatus);
      return (
        status === LeaseAuditStatus.PendingSubmit ||
        status === LeaseAuditStatus.Rejected
      );
    },
    canCreateContract: function(row) {
      // 已审核通过且无有效合同时可创建（有合同时走查看合同）
      return (
        Number(row.auditStatus) === LeaseAuditStatus.Approved &&
        !row.contractId
      );
    },
    canViewContract: function(row) {
      // 标的物已关联有效合同，且非待提交/待审核时可查看
      var audit = Number(row.auditStatus);
      return (
        !!row.contractId &&
        audit !== LeaseAuditStatus.PendingSubmit &&
        audit !== LeaseAuditStatus.Pending
      );
    },
    buildQuery: function() {
      var q = {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize || 10
      };
      if (this.filters.propertyCode) q.propertyCode = this.filters.propertyCode;
      if (this.filters.subType !== "" && this.filters.subType != null) {
        q.subType = this.filters.subType;
      }
      if (this.filters.status !== "" && this.filters.status != null) {
        q.status = this.filters.status;
      }
      if (this.filters.auditStatus !== "" && this.filters.auditStatus != null) {
        q.auditStatus = this.filters.auditStatus;
      }
      return q;
    },
    resetSearch: function() {
      this.filters = {
        propertyCode: "",
        subType: "",
        status: "",
        auditStatus: ""
      };
      this.loadList(1);
    },
    loadList: function(pageNum) {
      var self = this;
      if (pageNum) {
        this.pageInfo.pageNumber = pageNum;
      }
      this.loading = true;
      pageProperty(this.buildQuery())
        .then(function(res) {
          var data = (res && res.data) || {};
          self.list = data.list || [];
          self.pageInfo.totalPages = data.total || 0;
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
        })
        .then(function() {
          self.loading = false;
        });
    },
    handleAdd: function() {
      this.$refs.formDialog.openAdd();
    },
    handleEdit: function(row) {
      this.$refs.formDialog.openEdit(row);
    },
    goDetail: function(row) {
      this.$router.push({
        path: "/fishPondLease/propertyDetail",
        query: { id: row.id }
      });
    },
    goCreateContract: function(row) {
      this.$router.push({
        path: "/fishPondLease/contractForm",
        query: { propertyId: row.id }
      });
    },
    goViewContract: function(row) {
      this.$router.push({
        path: "/fishPondLease/contractDetail",
        query: { id: row.contractId }
      });
    },
    openImport: function() {
      this.$refs.importDialog.open();
    },
    handleDelete: function(row) {
      var self = this;
      this.$confirm("确认删除该标的物吗？", "提示", {
        type: "warning"
      })
        .then(function() {
          return deleteProperty(row.id);
        })
        .then(function() {
          self.$message.success("删除成功");
          self.loadList();
        })
        .catch(function(e) {
          if (e === "cancel" || e === "close") return;
          self.$message.error(leaseRequestError(e));
        });
    },
    handleSubmit: function(row) {
      var self = this;
      this.$confirm("确认提交审核吗？", "提示", {
        type: "warning"
      })
        .then(function() {
          return submitPropertyAudit({ id: row.id });
        })
        .then(function() {
          self.$message.success("已提交审核");
          self.loadList();
        })
        .catch(function(e) {
          if (e === "cancel" || e === "close") return;
          self.$message.error(leaseRequestError(e));
        });
    },
    openDisable: function(row) {
      this.currentRow = row;
      this.disableReason = "";
      this.disableVisible = true;
    },
    confirmDisable: function() {
      var self = this;
      if (!this.disableReason || !String(this.disableReason).trim()) {
        this.$message.warning("请输入禁用原因");
        return;
      }
      if (!this.currentRow) return;
      this.disabling = true;
      disableProperty({
        id: this.currentRow.id,
        disableReason: String(this.disableReason).trim()
      })
        .then(function() {
          self.$message.success("已禁用");
          self.disableVisible = false;
          self.loadList();
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
        })
        .then(function() {
          self.disabling = false;
        });
    }
  }
};
</script>
